exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-tag[data-v-6745fa69]{\n  cursor: pointer;\n}\n", ""]);

// exports
